import React from 'react'
import Test from '../../Pages/Test'
import Footer from '../../sub-components/Footer'
import Cards1 from '../../sub-components/Cards1'
import Header from '../../sub-components/Header'
import SliderOffer from '../../sub-components/SliderOffer'
import SliderBranches from '../../sub-components/SliderBranches'
import { useSelector, useDispatch } from 'react-redux'
import MenuCategory from '../../sub-components/MenuCategory'
import TopRatedRestaurants from '../../sub-components/TopRatedRestaurants'
import TopRatedMenus from '../../sub-components/HighRatedMenus'
import NewMenus from '../../sub-components/NewMenus'
import Offers from '../../sub-components/Offers'
import HomeCategories from '../../sub-components/HomeCategories'
import Google from "../../components/assets/google.png"
import GoogleAds from '../../GoogleAds'
import AdSense from 'react-adsense';
import {Adsense} from '@ctrl/react-adsense';
import GoogleAd from 'react-google-ad'

function Home() {
  const latitude = useSelector((state) => state.latitude);
  const longitude = useSelector((state) => state.longitude);
  const dispatch = useDispatch();

  console.log(latitude)
  return (
    <div>
              <div className="grocery-theme">
        {/* ============================================================== */}
        {/* Preloader - style you can find in spinners.css */}
        {/* ============================================================== */}
        {/* <div id="preloader"><div className="preloader"><span /><span /></div></div> */}
        {/* ============================================================== */}
        {/* Main wrapper - style you can find in pages.scss */}
        {/* ============================================================== */}
        <div id="main-wrapper">
          {/* ============================================================== */}
          {/* Top header  */}
          {/* ============================================================== */}
          {/* Start Navigation */}
<Header/>

             <HomeCategories />

       <TopRatedRestaurants />
      {/* <GoogleAds /> */}
      {/* <GoogleAd client='ca-pub-9058298844141347' slot="4493379164" format="fluid" /> */}
      {/* <Adsense
  client='ca-pub-9058298844141347'
  slot='4493379164'
  style={{ display: 'block' }}
  layout="in-article"
  format="fluid"
/> */}

      {/* <AdSense.Google
  client='ca-pub-9058298844141347'
  slot='4493379164'
  style={{ display: 'block' }}
  format='auto'
  responsive='true'
  layoutKey='-gw-1+2a-9x+5c'
/> */}

      {/* <div style={{marginTop:-100}} className="section145">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-title-tt">
                <div className="main-title-left">
                  <span>Offers</span>
                  <h2>Best Values</h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <a href="#" className="best-offer-item">
                <img src="assets1/images/best-offers/offer-1.jpg" alt="" />
              </a>
            </div>
            <div className="col-lg-4 col-md-6">
              <a href="#" className="best-offer-item">
                <img src="assets1/images/best-offers/offer-2.jpg" alt="" />
              </a>
            </div>
            <div className="col-lg-4 col-md-6">
              <a href="#" className="best-offer-item offr-none">
                <img src="assets1/images/best-offers/offer-3.jpg" alt="" />
                <div className="cmtk_dt">
                  <div className="product_countdown-timer offer-counter-text" data-countdown="2022/08/09" />
                </div>
              </a>
            </div>
            <div className="col-md-12">
              <a href="#" className="code-offer-item">
                <img src="assets1/images/best-offers/offer-4.jpg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div> */}
      <TopRatedMenus/>

       <NewMenus />

<Offers/>



  <Footer /> 
        </div>
      </div>
    </div>
  )
}

export default Home